import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';


import { OAuthService, AuthConfig, OAuthErrorEvent, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map, take, skip } from 'rxjs/operators';
import { SystemConfigurationService } from './admin/system-configuration/shared/services/system-configuration.service';
import { AppInitService } from './app-init.service';
import { TenantModel } from './core/models/tenant';
import { authConfig, GlobalDataService } from './shared/services/global-data.service';
import { MessageHubService } from './shared/services/message-hub.service';
import { getIsSystemConfigDataLoaded, getLocationSelected, getLoggedInUserId, getSignedInStatus, getUserFullName } from 'src/app/state/index';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { UserSigninStatus } from 'src/app/shared/enums/UserSigninStatus.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { UserSigninStatusModel } from 'src/app/lobby/shared/models/lobby-user-signin-status.model';
import * as CoreActions from 'src/app/state/actions/core.actions';
import { getCurrentTenant } from 'src/app/state';
import { BusyService } from './core/services/busy.service';
import { TranslateService } from '@ngx-translate/core';
import isEmpty from 'lodash/isEmpty';
import { MasterMyProfileComponent } from './master/master-my-profile/master-my-profile.component';
import { MasterMyProfileService } from './master/master-services/master-my-profile.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})




export class AppComponent {
  title = 'KRONOS-FMSI-CC';
  isFromConferenceEmail = false;
  username: any;
  private userActivity?: NodeJS.Timeout;
  private subs: Subscription = new Subscription();
  private unsignedStatus: UserSigninStatusModel = <UserSigninStatusModel>{};
  private timeoutValue: number = 60; // Defining a default value until the value can be assigned for the first time
  public systemConfigLoaded:boolean=false;
  public appComponentSubscription= new Subscription();;
  private translateService: TranslateService;
  constructor(
    private router: Router,
    private oauthService: OAuthService,
    private session: SessionService,
    private appInitService: AppInitService,
    private globalDataService: GlobalDataService,
    private systemConfigService: SystemConfigurationService,
    private store: Store<State>,
    private spinner: BusyService,
    translate: TranslateService, private myProfileService: MasterMyProfileService,
    private route: ActivatedRoute
      ) {

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this._updateTimeOutConfiguration();
    }, 15000);
    this.translateService = translate;
    translate.setDefaultLang('en-US');
  }

  ngOnInit() {
    if (this.getRedirectionStateFromConferencingProviderAuth() == '') {
    
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.route.queryParams.subscribe(params => {
            if (params['source'] === 'email') {
              this.isFromConferenceEmail = true;
            }
          });
        }
      });
   
      this.spinner.busy();

      this.oauthService.events.subscribe((e) => {
        if (e instanceof OAuthErrorEvent && e.type === 'token_refresh_error') {
          alert(e);
          this.globalDataService.logout();
        }
      });

      this._configurreAuthLibrary().subscribe(config => this._intiateAuthentiacation(config));

      this.appComponentSubscription.add(this.store.select(getIsSystemConfigDataLoaded)
        .subscribe((status: any) => {
        this.systemConfigLoaded=status;
          this.spinner.idle();
        })
      );
    }
    else {
      
        /**
         * When an external virtual conferencing provider redirects back to BC,
         * the root component (this) loads in a new window and the authorization code is extracted.
         * The extracted authorization code is posted to the parent window that opened the external
         * authentication window. The parent window mounts the "master/my-profile" component.
         *
         * "master/my-profile" component contains the event handler to catch the authorization code.
         */
        MasterMyProfileComponent.postAuthorizationCodeToParentWindow();
	}
  }
  private hasLoginParam(): boolean {
    const initialPath = window.location.href;
    const params = new URLSearchParams(new URL(initialPath).search);
    return params.get('login') != null;
  }
  private getRedirectionStateFromConferencingProviderAuth(): string {
    let myProfile = this.myProfileService.appConfig?.authentication.myAccountUrl ?? '';
    const initialPath = window.location.href;
    const params = new URLSearchParams(new URL(initialPath).search);
    const code = params.get('code');
    const baseUrl = initialPath.split('?')[0];
    if (baseUrl==myProfile && code!=null)
    {
      return code;

    }
    else {
      return '';
    }
   
  }

  ngOnDestroy(): void {
    this.appComponentSubscription.unsubscribe();
  }

  private _configurreAuthLibrary(): Observable<AuthConfig> {
    return this.appInitService.getAppConfiguration$().pipe(
      map(appConfig => {
        return {
          issuer: appConfig.authentication.issuer,
          redirectUri: appConfig.authentication.redirectUri,
          clientId: appConfig.authentication.clientId,
          scope: appConfig.authentication.clientscope,
          strictDiscoveryDocumentValidation: appConfig.authentication.strictDiscoveryDocumentValidation,
          responseType: appConfig.authentication.responseType,
          showDebugInformation: appConfig.authentication.showDebugInformation,
          postLogoutRedirectUri: appConfig.authentication.postLogoutRedirectUri,
          logoutUrl: appConfig.authentication.logoutUrl,
          requireHttps: false
        }
      }),
      take(1)
    );
  }

  private _intiateAuthentiacation(authConfig: AuthConfig) {
    this.spinner.busy();
    if (this.hasLoginParam()) {
      this.globalDataService.logout();
	}

    const urlParams = new URLSearchParams(window.location.search);
    const tenantIdFromUrl = urlParams.get('tenantId');

    const tenantFromLocalStorage = localStorage.getItem('tenant');
    const tenant: TenantModel =  tenantFromLocalStorage != null ? JSON.parse(tenantFromLocalStorage) : <TenantModel>{};
    const switchCode = localStorage.getItem('switch_code');
    
    const customQueryParams: any = {};
    
    if (tenantIdFromUrl) {
      customQueryParams.tenantId = tenantIdFromUrl;
    }
    
    if (tenant && !isEmpty(tenant) && (tenant.isDefault || (tenant.tenantID && switchCode))) {
      customQueryParams.tenant = tenant.tenantID;
      customQueryParams.switchcode = switchCode;
      localStorage.removeItem('tenant_id');
      localStorage.removeItem('tenant');
      localStorage.removeItem('switch_code');
    }
    
    if (Object.keys(customQueryParams).length > 0) {
      this.oauthService.configure({ ...authConfig, customQueryParams });
    } else {
      this.oauthService.configure(authConfig);
    }

    this.oauthService.loadDiscoveryDocumentAndLogin().then(() => {
      if (this.oauthService.hasValidAccessToken()) {
        this.spinner.idle();
        this.globalDataService.setAccessToken(this.oauthService.getAccessToken());
        this.globalDataService.setIdToken(this.oauthService.getIdToken());
        if (this.isFromConferenceEmail) {
          this.router.navigate(['/master/my-profile']);
        }
        else{
          this.router.navigate(['/dashboard/dashboard-landing']);
        }
        
        this._updateTimeOutConfiguration();
      }
    });

    this.oauthService.setupAutomaticSilentRefresh();
  }



  private _updateTimeOutConfiguration() {
    this.subs.add(
      this.systemConfigService.getSystemConfigurationForRoot().subscribe(
        configs => {
          this.timeoutValue = parseInt(configs.filter(c => c.configurationGroup === 'BasicSettings' && c.configurationName === 'TimeOutDuration')[0].value);
          console.log('Timeout: ' + this.timeoutValue);
          this._setTimeout();
        },
        error => {
          console.log('Error retrieving timeout');
          setTimeout(() => {
            /** spinner ends after 5 seconds */
            this._updateTimeOutConfiguration();
          }, 15000);
        }
      ));
  }

  public logout() {
    // bug fix for BCDT-142 //
    /* solution tries to signout user first before logging out, this way even
             - if the user has a lobby record requested for him waiting in lobby
             - or if hes the last person to signed in also
                     he cant logout */

    this.store.select(getSignedInStatus).pipe(take(1))
      .subscribe((status: any) => {
        if (status!=null &&(status.statusId === UserSigninStatus.Idle || status.statusId === UserSigninStatus.Assisting)) {
          this._signOut();
        }
        else{
          this.globalDataService.logout();
        }
      });
  }

  private _signOut() {
    let combinedsubs = combineLatest(
      [
        this.store.select(getCurrentTenant),
        this.store.select(getSignedInStatus),
        this.store.select(getLoggedInUserId),
        this.store.select(getLocationSelected)
      ]).pipe(
        map(([tenant, signedInStatus, userId, location]) => {

          if (signedInStatus == null) {
            this.unsignedStatus = {
              userId: userId ?? 0,
              locationId: location.homeLocationId ?? 0,
              statusId: 3,
              status: 'Offline',
              statusReason: '',
              currentAssistingLobbyEntryId: 0,
              locationCode: '',
              currentAssistingLocationId:0,
              impersonateById:null,
              impersonateByName:null

            }
          }

          return {
            tenantId: tenant.tenantID,
            userId: signedInStatus?.userId ?? userId,
            locationId: signedInStatus?.locationId ?? location.homeLocationId,
            reason: ''
          }
        }),
        take(1)
      );

    this.session.clearSignInSession();
    this.session.clearLobbyLocation();
    combinedsubs.subscribe(payload =>
      this._dispatchSignoutAction(payload)
    );

  }

  private _dispatchSignoutAction(payload: any) {
    this.store.dispatch(CoreActions.userTimeOut({ payload }))
  }

  private _setTimeout() {
    if (this.userActivity) {
      clearTimeout(this.userActivity);
    }
    this.userActivity = setTimeout(() =>
      this.logout(), this.timeoutValue * 1000 * 60
    );
  }

  @HostListener('window:keyup') onKeyPress() {
    this._resetTimeOut();
  }
  @HostListener('window:mousemove') onMouseMove() {
    this._resetTimeOut();
  }

  private _resetTimeOut() {
    clearTimeout(this.userActivity);
    this._setTimeout();
  }
}


